// src/pages/RetiredAccountPage.js
// "This account area is paused" — the landing screen for legacy CRM accounts
// (client-portal parents and business owners) now that those surfaces are
// disabled (2026-08-23, REMOVED-CRM-ROUTES in App.js / RoleGate.js). The
// service-business platform is dormant, not deleted — when it's revived,
// restore RoleGate's original redirects and this page goes back to being
// unreachable. Modeled on FindingAcademyPage (same standalone shape).

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthService from "../services/auth.service";
import "./client/clientTheme.css";

const THEME_KEY = "polyp_theme";

export default function RetiredAccountPage() {
  const navigate = useNavigate();
  const [theme] = useState(() => {
    if (typeof window === "undefined") return "dark";
    return localStorage.getItem(THEME_KEY) || "dark";
  });

  useEffect(() => {
    document.title = "Account Paused · Polyp";
  }, []);

  const handleSignOut = async () => {
    try { await AuthService.logout(); } catch (_) {}
    navigate("/login", { replace: true });
  };

  return (
    <div
      className={`client-page${theme === "light" ? " light-theme" : ""}`}
      style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24 }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 460,
          background: "var(--bg-card)",
          border: "1px solid var(--border-subtle)",
          borderRadius: 18,
          padding: "32px 28px",
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: 44, marginBottom: 12 }} aria-hidden>⏸️</div>
        <h1
          style={{
            fontFamily: "var(--font-heading, sans-serif)",
            color: "var(--text-primary)",
            fontSize: 26,
            fontWeight: 800,
            margin: "0 0 10px",
          }}
        >
          This account area is paused
        </h1>
        <p style={{ color: "var(--text-secondary)", fontSize: 15, lineHeight: 1.5, margin: "0 0 8px" }}>
          Polyp is now PlayerWiki Manager — for leagues, coaches, and game officials.
          Your account and its data are safe; this area is just offline for now.
        </p>
        <p style={{ color: "var(--text-secondary)", fontSize: 15, lineHeight: 1.5, margin: 0 }}>
          Following a player or claiming your player's profile? That all lives
          on{" "}
          <a href="https://polyp.me" style={{ color: "var(--accent, #33cc66)", fontWeight: 700 }}>
            PlayerWiki
          </a>
          . A coach or official? Sign up fresh, or use the invite link your
          league texted you.
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: 10, marginTop: 22 }}>
          <a href="https://polyp.me" style={{ ...primaryBtn, display: "block", textDecoration: "none" }}>
            Open PlayerWiki
          </a>
          <button onClick={() => navigate("/security")} style={ghostBtn}>
            Manage account & sign-in
          </button>
          <button onClick={handleSignOut} style={ghostBtn}>
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}

const primaryBtn = {
  background: "var(--accent, #33cc66)",
  color: "#0b1f12",
  border: "none",
  borderRadius: 10,
  padding: "12px 16px",
  fontSize: 15,
  fontWeight: 700,
  cursor: "pointer",
};

const ghostBtn = {
  background: "transparent",
  color: "var(--text-secondary)",
  border: "1px solid var(--border-subtle)",
  borderRadius: 10,
  padding: "12px 16px",
  fontSize: 15,
  fontWeight: 600,
  cursor: "pointer",
};
